import { gql } from 'graphql-request';

const request = {
	request: {
		name: 'auth>forgot_password_reset'
	},

	// OLD!
	validation: {
		password: {
			required: true,
			validator: null
		},

		password_repeat: {
			required: true,
			validator: null
		},

		hash: {
			required: true,
			validator: null
		}
	},

	gql: {
		schema: gql`
			mutation ForgotPasswordReset(
			  $password: String,
				$password_repeat: String,
				$hash: String
			) {
			  request(
					password: $password,
					password_repeat: $password_repeat,
					hash: $hash
			  ) {
			    username
			  }
			}
		`
	}
};

export default request;
